<template>
  <div class="animated fadeIn">
    <b-row class="pt-4">
      <b-col>
        <p>Feel free to use these sample HIPAA forms. Most will require customization, .e.g., add your business contact information.</p>
        <p>DISCLAIMER: Because of the generality of these sample forms, the information provided herein may not be applicable in every situation and should not be acted upon without specific legal advice.</p>

        <div class="py-3" v-for="(category, catIdx) in sampleForms" :key="'category-' + catIdx">
          <h4>{{category.category}}</h4>

          <div role="tablist" class="pt-4">
            <b-card no-body class="mb-1" v-for="(form, formIdx) in category.forms" :key="'category-' + catIdx + '-' + formIdx">
              <b-card-header header-tag="header" class="p-2" role="tab" v-b-toggle="'accordian-' + catIdx + '-' + formIdx">
                {{form.title}}
                <div class="when-opened float-right px-2">
                  <i class="icon-arrow-down small pl-2"></i>
                </div>
                <div class="when-closed float-right px-2">
                  <i class="icon-arrow-left small pl-2"></i>
                </div>
              </b-card-header>

              <b-collapse :id="'accordian-' + catIdx + '-' + formIdx" visible accordion="forms-accordion" role="tabpanel">
                <b-card-body>
                  <p>{{form.desc}}</p>
                  <div v-for="file in form.files" :key="file.name">
                    <i :class="'pr-2 fa ' + file.icon"></i>
                    <a :href="file.url" target="_blank">{{file.name}}</a>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'SampleForms',
  data() {
    return {
      sampleForms: [{
        category: 'Patient Forms',
        forms: [{
          title: 'Email and Text Message Authorization',
          desc: 'Always obtain a patient\'s authorization if you ever send, or intend to send, protected health information (PHI) via email or text message. Automated appointment reminders, for example, require patient authorization because reminders contain PHI and are being sent to an unsecure location—the patient\'s phone or email.',
          files: [{
            name: 'Email and Text Authorization (pdf)',
            url: 'download/Email Authorization.pdf',
            icon: 'fa-file-pdf-o'
          }, {
            name: 'Email and Text Authorization (docx)',
            url: 'download/Email Authorization.docx',
            icon: 'fa-file-word-o'
          }, {
            name: 'Email and Text Authorization (pages)',
            url: 'download/Email Authorization.pages',
            icon: 'fa-file-o'
          }]
        }, {
          title: 'Testimonial Authorization',
          desc: 'When it comes to growing a business, patient testimonials are extremely powerful. However, they can quickly become a HIPAA problem if not handled with care. Obtaining a patient\'s consent to use their testimonial (e.g., written, video, picture) must go well beyond a single sentence or a verbal agreement. True \"consent\" must be informative and comprehensive.',
          files: [{
            name: 'Patient Testimonial Authorization (pdf)',
            url: 'download/Patient Testimonial.pdf',
            icon: 'fa-file-pdf-o'
          }, {
            name: 'Patient Testimonial Authorization (docx)',
            url: 'download/Patient Testimonial.docx',
            icon: 'fa-file-word-o'
          }, {
            name: 'Patient Testimonial Authorization (pages)',
            url: 'download/Patient Testimonial.pages',
            icon: 'fa-file-o'
          }]
        }, {
          title: 'Family/Friends Disclosure Authorization',
          desc: 'For use when a patient wants to give you permission to communicate with other people regarding his or her care.',
          files: [{
            name: 'Family/Friends Disclosure Authorization (pdf)',
            url: 'download/Family Disclosure.pdf',
            icon: 'fa-file-pdf-o'
          }, {
            name: 'Family/Friends Disclosure Authorization (docx)',
            url: 'download/Family Disclosure.docx',
            icon: 'fa-file-word-o'
          }, {
            name: 'Family/Friends Disclosure Authorization (pages)',
            url: 'download/Family Disclosure.pages',
            icon: 'fa-file-o'
          }]
        }, {
          title: 'HIPAA Privacy Complaint',
          desc: 'Use this form when a patient or client wants to file a privacy complaint with your office. Meaning, the patient feels you\'ve committed a HIPAA violation. At the bottom of the form there is a section to document that an internal review occurred. This is used to help prove the patient\'s complaint was not ignored by your office. Depending on the situation, you may also want to complete the Security Incident Response Form.',
          files: [{
            name: 'HIPAA Privacy Complaint (pdf)',
            url: 'download/HIPAA Privacy Complaint.pdf',
            icon: 'fa-file-pdf-o'
          }, {
            name: 'HIPAA Privacy Complaint (docx)',
            url: 'download/HIPAA Privacy Complaint.docx',
            icon: 'fa-file-word-o'
          }, {
            name: 'HIPAA Privacy Complaint (pages)',
            url: 'download/HIPAA Privacy Complaint.pages',
            icon: 'fa-file-o'
          }]
        }, {
          title: 'Notice of Privacy Practices',
          desc: 'You must make a good faith effort to obtain an individual\'s written acknowledgment that they have received your Notice of Privacy Practices no later than the date of first service. This is a one-time only activity; you do not need to obtain acknowledgement from an individual more than once. For example, there is no requirement to obtain patient signatures annually.',
          files: [{
            name: 'Notice of Privacy Practices (pdf)',
            url: 'download/Notice of Privacy Practices.pdf',
            icon: 'fa-file-pdf-o'
          }, {
            name: 'Notice of Privacy Practices (docx)',
            url: 'download/Notice of Privacy Practices.docx',
            icon: 'fa-file-word-o'
          }, {
            name: 'Notice of Privacy Practices (pages)',
            url: 'download/Notice of Privacy Practices.pages',
            icon: 'fa-file-o'
          }]
        }]
      }, {
        category: 'Workforce (Employee) Forms',
        forms: [{
          title: 'Sanction Policy',
          desc: 'A sanction policy is a contract in which workforce members agree to protect the confidentiality, integrity, and availability of sensitive information at all times. The policy also details imposed sanctions on any individual who accesses, uses, or discloses sensitive information without proper authorization. All workforce members must sign this document.',
          files: [{
            name: 'Sanction Policy (pdf)',
            url: 'download/Sanction Policy.pdf',
            icon: 'fa-file-pdf-o'
          }, {
            name: 'Sanction Policy (docx)',
            url: 'download/Sanction Policy.docx',
            icon: 'fa-file-word-o'
          }, {
            name: 'Sanction Policy (pages)',
            url: 'download/Sanction Policy.pages',
            icon: 'fa-file-o'
          }]
        }, {
          title: 'Background Check Authorization',
          desc: 'The HIPAA law does not require employee background checks. A sample form is below, however, if you are performing background checks then you probably have a more appropriate form provided by the background check service being utilized.',
          files: [{
            name: 'Background Check Authorization (pdf)',
            url: 'download/Background Check Authorization.pdf',
            icon: 'fa-file-pdf-o'
          }, {
            name: 'Background Check Authorization (docx)',
            url: 'download/Background Check Authorization.docx',
            icon: 'fa-file-word-o'
          }, {
            name: 'Background Check Authorization (pages)',
            url: 'download/Background Check Authorization.pages',
            icon: 'fa-file-o'
          }]
        }]
      }, {
        category: 'Business Associate Forms',
        forms: [{
          title: 'Business Associate Agreement (BAA)',
          desc: 'DISCLAIMER: This document includes sample business associate agreement provisions to help covered entities and business associates more easily comply with the business associate contract requirements. While these sample provisions are written for the purposes of the contract between a covered entity and its business associate, the language may be adapted for purposes of the contract between a business associate and subcontractor. This is only sample language and use of these sample provisions is not required for compliance with the HIPAA Rules. The language may be changed to more accurately reflect business arrangements between a covered entity and business associate or business associate and subcontractor. In addition, these or similar provisions may be incorporated into an agreement for the provision of services between a covered entity and business associate or business associate and subcontractor, or they may be incorporated into a separate business associate agreement. These provisions address only concepts and requirements set forth in the HIPAA Privacy, Security, Breach Notification, and Enforcement Rules, and alone may not be sufficient to result in a binding contract under State law. Reliance on this sample may not be sufficient for compliance with State law, and does not replace consultation with a lawyer or negotiations between the parties to the contract.',
          files: [{
            name: 'Business Associate Agreement (pdf)',
            url: 'download/BA Agreement Template.pdf',
            icon: 'fa-file-pdf-o'
          }, {
            name: 'Business Associate Agreement (docx)',
            url: 'download/BA Agreement Template.docx',
            icon: 'fa-file-word-o'
          }, {
            name: 'Business Associate Agreement (pages)',
            url: 'download/BA Agreement Template.pages',
            icon: 'fa-file-o'
          }]
        }]
      }, {
        category: 'Unauthorized Disclosure Forms',
        forms: [{
          title: 'Security Incident Response',
          desc: 'Use this form to document your office\'s response if you suspect protected health information (patient information) was disclosed, or may have been disclosed, to unauthorized individuals. For example, an email sent to the wrong patient, theft of a computer, and a network attack would all require completing this form.',
          files: [{
            name: 'Security Incident Response (pdf)',
            url: 'download/Security Incident Response Form.pdf',
            icon: 'fa-file-pdf-o'
          }, {
            name: 'Security Incident Response (docx)',
            url: 'download/Security Incident Response Form.docx',
            icon: 'fa-file-word-o'
          }, {
            name: 'Security Incident Response (pages)',
            url: 'download/Security Incident Response Form.pages',
            icon: 'fa-file-o'
          }]
        }]
      }, {
        category: 'Non-Workforce / Non-Business Associate Forms',
        forms: [{
          title: 'Confidentiality Agreement',
          desc: 'For use when an entity or person is in your office but they are not directly involved with creating, receiving, using, disclosing or maintaining your PHI. For example, an office cleaning service may have access to patient information even though the job they are performing doesn\'t involve patient information.',
          files: [{
            name: 'Confidentiality Agreement (pdf)',
            url: 'download/Confidentiality Agreement.pdf',
            icon: 'fa-file-pdf-o'
          }, {
            name: 'Confidentiality Agreement (docx)',
            url: 'download/Confidentiality Agreement.docx',
            icon: 'fa-file-word-o'
          }, {
            name: 'Confidentiality Agreement (pages)',
            url: 'download/Confidentiality Agreement.pages',
            icon: 'fa-file-o'
          }]
        }]
      }]
    }
  }
}
</script>

<style>
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
</style>